<template>
  <div class="box p-3">
    <div v-if="isAddressLoading" class="has-text-centered">
      <PulseLoader :loading="true" color="#00d1b2" size="12px"></PulseLoader>
    </div>
    <div v-else>
      <!-- Header with title and type badge -->
      <div class="columns is-multiline mb-2">
        <div class="column is-full">
          <div class="is-flex is-justify-content-space-between is-align-items-end">
            <div class="field">
              <label class="label is-small mb-0">Name</label>
              <div class="control">
                <input class="input is-small" v-model="DistributionZoneName" type="text" />
              </div>
            </div>
            <!-- Type selector in header that syncs with details tab -->
            <div class="field">
              <label class="label is-small mb-0">Type</label>
              <div class="control">
                <div class="select is-small">
                  <select v-model="DistributionZoneType">
                    <option v-for="type in store.getters.DistributionZoneTypes" :key="type.value" :value="type">
                      {{ type.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Main content in tabs -->
      <div class="tabs is-small is-success mb-2">
        <ul>
          <li :class="{ 'is-active': activeTab === 'location' }">
            <a @click="activeTab = 'location'">Location</a>
          </li>
          <li v-if="DistributionZoneType.label !== 'CENTER ZONE'" :class="{ 'is-active': activeTab === 'details' }">
            <a @click="activeTab = 'details'">Details</a>
          </li>
          <li v-if="DistributionZoneType.label !== 'CENTER ZONE'" :class="{ 'is-active': activeTab === 'features' }">
            <a @click="activeTab = 'features'">Features</a>
          </li>
          <li v-if="DistributionZoneType.label !== 'CENTER ZONE'"
            :class="{ 'is-active': activeTab === 'daysOfService' }">
            <a @click="activeTab = 'daysOfService'">Days of Service</a>
          </li>
        </ul>
      </div>

      <!-- Tab content container with fixed height -->
      <div class="tab-content-container">
        <!-- Location Tab -->
        <div v-if="activeTab === 'location'" class="tab-content">
          <div class="columns is-multiline is-mobile">
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Region</label>
                <div class="control">
                  <div class="select is-small is-fullwidth">
                    <select v-model="Region.id">
                      <option v-for="region in store.state.regions" :key="region.id" :value="region.id">
                        {{ region ? region.name : "" }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Search Address</label>
                <div class="control">
                  <input class="input is-small" type="text" ref="autocomplete" placeholder="Enter a location"
                    @focus="onInputFocus" />
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Coordinates (Lat/Lng)</label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <input class="input is-small" v-model.number="Latitude" type="number"
                      :disabled="geocoding_loading" />
                  </div>
                  <div class="control is-expanded">
                    <input class="input is-small" v-model.number="Longitude" type="number"
                      :disabled="geocoding_loading" />
                  </div>
                  <div class="control">
                    <button class="button is-small is-borderless" @click="getCoordinates"
                      :class="{ 'is-loading': geocoding_loading || loading }">
                      Get
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="columns is-mobile">
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Country</label>
                    <div class="control">
                      <div class="select is-small is-fullwidth">
                        <select v-model="Country">
                          <option v-for="country in store.getters.Countries" :key="country.value" :value="country">
                            {{ country.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Province</label>
                    <div class="control">
                      <div class="select is-small is-fullwidth">
                        <select v-model="Province">
                          <option v-for="province in store.getters.TaxProvinces" :key="province.Province"
                            :value="province.Province">
                            {{ province.Province }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="columns is-mobile">
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">City</label>
                    <div class="control">
                      <input class="input is-small" v-model="City" type="text" />
                    </div>
                  </div>
                </div>
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Postal Code</label>
                    <div class="control">
                      <input class="input is-small" v-model="PostalCode" type="text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="columns is-mobile">
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Door Number</label>
                    <div class="control">
                      <input class="input is-small" v-model="DoorNumber" type="text" />
                    </div>
                  </div>
                </div>
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Apartment</label>
                    <div class="control">
                      <input class="input is-small" v-model="Apartment" type="text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Street</label>
                <div class="control">
                  <input class="input is-small" v-model="Street" type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Details Tab -->
        <div v-if="activeTab === 'details'" class="tab-content">
          <div class="columns is-multiline is-mobile">
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Facility</label>
                <div class="control">
                  <div class="select is-fullwidth is-small">
                    <select v-model="Facility">
                      <option v-for="type in store.getters.Facility" :key="type" :value="type">
                        {{ type }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half" v-if="DistributionZoneType.label === 'STORE'">
              <div class="field">
                <label class="label is-small mb-0">Client</label>
                <div class="control">
                  <div class="select is-fullwidth is-small">
                    <select v-model="Vendor">
                      <option v-for="vendor in store.state.vendors" :key="vendor.Id" :value="vendor.Id">
                        {{ vendor.businessUnit }}***{{ vendor.subBusinessUnit }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Phone</label>
                <div class="control">
                  <input class="input is-small" v-model="PhoneNumber" type="tel" placeholder="xxxxxxxxxx" />
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Size (Sq. Ft.)</label>
                <div class="control">
                  <input class="input is-small" v-model.number="Size" type="number" />
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Number Of Employees</label>
                <div class="control">
                  <input class="input is-small" v-model.number="NumberOfEmployees" type="number" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Features Tab -->
        <div v-if="activeTab === 'features'" class="tab-content">
          <div class="field mb-3">
            <label class="label is-small mb-2">Distribution Zone Features</label>
            <div class="tags">
              <span class="tag is-small" :class="{ 'is-primary': IsFinalMile, 'is-light': !IsFinalMile }"
                @click="IsFinalMile = !IsFinalMile">
                Final Mile
              </span>
              <span class="tag is-small" :class="{
                'is-primary': IsForReverse,
                'is-light': !IsForReverse,
              }" @click="IsForReverse = !IsForReverse">
                Reverse Logistics
              </span>
              <span class="tag is-small" :class="{
                'is-primary': AllowCrossdock,
                'is-light': !AllowCrossdock,
              }" @click="AllowCrossdock = !AllowCrossdock">
                Crossdock
              </span>
              <span class="tag is-small" :class="{
                'is-primary': AllowOvernightReception,
                'is-light': !AllowOvernightReception,
              }" @click="AllowOvernightReception = !AllowOvernightReception">
                Overnight Reception
              </span>
              <span class="tag is-small" :class="{
                'is-primary': shouldConsiderFuelSurcharge,
                'is-light': !shouldConsiderFuelSurcharge,
              }" @click="
                shouldConsiderFuelSurcharge = !shouldConsiderFuelSurcharge
                ">
                Fuel Surcharge
              </span>
            </div>
          </div>

          <div class="field mb-3">
            <label class="label is-small mb-2">Data Source</label>
            <div class="tags">
              <span class="tag is-small" :class="{ 'is-success': IsCDSRegion, 'is-light': !IsCDSRegion }"
                @click="IsCDSRegion = !IsCDSRegion">
                Shyftbase
              </span>
              <span class="tag is-small" :class="{
                'is-success': IsCustomerRegion,
                'is-light': !IsCustomerRegion,
              }" @click="IsCustomerRegion = !IsCustomerRegion">
                External
              </span>
            </div>
          </div>
        </div>

        <!-- Days of Service Tab -->
        <div v-if="activeTab === 'daysOfService'" class="tab-content">
          <div class="field mb-3">
            <label class="label is-small mb-2">Select Days of Service</label>
            <div class="tags">
              <span v-for="day in daysOfWeek" :key="day.value" class="tag is-small" :class="{
                'is-primary': daysOfService[day.value],
                'is-light': !daysOfService[day.value],
              }" @click="toggleDay(day.value)">
                {{ day.label }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <div class="notification m-0 p-2" style="background-color: white">
            <div class="is-size-7 has-text-danger">
              {{ msg || err_message }}
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="field is-grouped is-grouped-right m-0">
            <p class="control m-1">
              <button @click="saveToFirestore" class="button is-small is-primary"
                :class="{ 'is-loading': isSaving || geocoding_loading }" style="border-radius: 5px"
                :disabled="isSaving">
                Save
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { hubsCollection, firestoreInstance } from "../store/fireStore";
import store from "../store";
import axios from "axios";
import * as leafletPip from "@mapbox/leaflet-pip";
import { geoJsonFeature } from "../views/utils";

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      activeTab: "location",
      isAddressLoading: false,
      isSaving: false,
      clientName: process.env.VUE_APP_SHYFTBASE_CUSTOMER_ID,
      DistributionZoneName: "",
      DistributionZoneId: "",
      Street: "",
      DoorNumber: "",
      Apartment: "",
      City: "",
      Province: "",
      PostalCode: "",
      DistributionZoneType: { value: 0, label: "PRIMARY" },
      Facility: "WAREHOUSE",
      Size: null,
      NumberOfEmployees: null,
      PhoneNumber: "",
      AllowCrossdock: false,
      IsFinalMile: false,
      IsForReverse: false,
      AllowOvernightReception: false,
      IsCDSRegion: false,
      shouldConsiderFuelSurcharge: false,
      IsCustomerRegion: false,
      loading: false,
      msg: "",
      Vendor: "",
      Color: "#007D6A",
      Region: {
        name: "",
        id: "",
      },
      store,
      Latitude: null,
      Longitude: null,
      err_message: "",
      geocoding_loading: false,
      TimeZone: "",
      Country: {
        label: "",
        value: "",
      },
      daysOfWeek: [
        { label: "Monday", value: "monday" },
        { label: "Tuesday", value: "tuesday" },
        { label: "Wednesday", value: "wednesday" },
        { label: "Thursday", value: "thursday" },
        { label: "Friday", value: "friday" },
        { label: "Saturday", value: "saturday" },
        { label: "Sunday", value: "sunday" },
      ],
      daysOfService: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
    };
  },
  props: {
    coordinates: {
      type: Object,
    },
    region: {
      type: String,
    },
    timeZone: {
      type: String,
    },
    fromTable: {
      type: Boolean,
    },
    closeModal: {
      type: Function,
    },
  },
  mounted() {
    if (this.coordinates) {
      this.Latitude = this.coordinates.lat;
      this.Longitude = this.coordinates.lng;
      this.getAddressFromCoordinates();
    }
    this.TimeZone = this.timeZone;
    this.err_message = "";

    // Add a global style to ensure autocomplete dropdown appears over modals
    const style = document.createElement("style");
    style.innerHTML = `
      .pac-container {
        z-index: 2000 !important;
      }
    `;
    document.head.appendChild(style);
  },
  watch: {
    DistributionZoneType: function (val) {
      // TODO: WE NEED TO SET THIS SETTING ON THE CONFIGURATIONS
      if (val.label === "STORE") {
        this.Color = "#DE5A35";
      } else if (val.label === "STEM") {
        this.Color = "#00d0c4";
      } else if (val.label === "SECONDARY") {
        this.Color = "#1184E8";
      } else if (val.label === "PRIMARY") {
        this.Color = "#007D6A";
      } else if (val.label === "CENTER ZONE") {
        this.Color = "#007D6A";
        // Switch to location tab when CENTER ZONE is selected
        this.activeTab = "location";
      }

      // Emit type change to update marker icon
      this.$emit('type-change', {
        type: val.label,
        color: this.Color
      });
    },
    Latitude(newVal) {
      this.emitCoordinateChange();
    },
    Longitude(newVal) {
      this.emitCoordinateChange();
    },
    activeTab(newVal, oldVal) {
      // When changing tabs, clean up any existing pac-containers
      if (oldVal === "location") {
        this.cleanupGoogleAutocomplete();
      }
    },
  },
  created() {
    const regions = store.state.regions;
    const currentRegionSelected = store.state.region;
    const selectedRegion = regions.find(
      (region) => region.id === currentRegionSelected
    );
    this.Region.name = selectedRegion ? selectedRegion.name : "";
    this.Region.id = selectedRegion ? selectedRegion.id : "";
    this.Province = selectedRegion ? selectedRegion.province : "";
  },
  methods: {
    close() {
      // Clean up Google autocomplete when modal closes
      this.cleanupGoogleAutocomplete();
      if (!this.fromTable) {
        this.$emit("close");
      } else {
        this.closeModal();
      }
    },
    // Add cleanup method for Google autocomplete
    cleanupGoogleAutocomplete() {
      // Remove autocomplete listeners if they exist
      if (this.autocomplete) {
        window.google.maps.event.clearInstanceListeners(this.autocomplete);
        this.autocomplete = null;
      }

      // Remove all pac-container elements from the document
      const pacContainers = document.querySelectorAll(".pac-container");
      pacContainers.forEach((container) => {
        container.remove();
      });

      // Clear the input if needed
      if (this.$refs.autocomplete) {
        this.$refs.autocomplete.blur(); // Remove focus
      }
    },
    emitCoordinateChange() {
      this.$emit("coordinate-change", {
        lat: this.Latitude,
        lng: this.Longitude,
      });
    },
    async saveToFirestore() {
      this.isSaving = true;
      const {
        DistributionZoneName,
        Street,
        DoorNumber,
        Apartment,
        City,
        Province,
        PostalCode,
        DistributionZoneType,
        Facility,
        Size,
        NumberOfEmployees,
        PhoneNumber,
        AllowCrossdock,
        IsFinalMile,
        IsForReverse,
        AllowOvernightReception,
        Color,
        Vendor,
        Latitude,
        Longitude,
        TimeZone,
        Country,
        daysOfService,
      } = this;
      if (
        DistributionZoneName &&
        Province &&
        Street &&
        City &&
        PostalCode &&
        Country.label
      ) {
        if (!this.Region.id) {
          this.msg = "Please Select a Region";
          this.isSaving = false;
          return;
        }

        if (Vendor === "" && DistributionZoneType.label === "STORE") {
          this.msg = "Please Select a Client";
          this.isSaving = false;
          return;
        }

        try {
          if (process.env.VUE_APP_FIREBASE_PID !== "metro-logistics") {
            try {
              await axios.post(
                `https://us-central1-${process.env.VUE_APP_FIREBASE_PID}.cloudfunctions.net/VALIDATIONS-uniqueChecks`,
                {
                  type: "distributionZone",
                  data: {
                    regionId: this.Region.id,
                    name: (DistributionZoneName || "").toUpperCase(),
                  },
                }
              );
            } catch (error) {
              this.loading = false;
              if (
                error.response &&
                error.response.data &&
                error.response.data.error === "distributionZone-exists"
              ) {
                this.msg = `${DistributionZoneName} already exists. Please use a different name.`;
              } else {
                this.msg = "Something went wrong, please try again.";
              }
              this.isSaving = false;
              return;
            }
          }

          const docRef = await hubsCollection.doc();
          const DistributionZoneId = docRef.id;
          const toFirestoreCoordinates = new firestoreInstance.GeoPoint(
            parseFloat(String(Latitude)),
            parseFloat(String(Longitude))
          );
          await docRef.set(
            {
              CustomFields: {
                IsCDSRegion: this.IsCDSRegion || false,
                IsCustomerRegion: this.IsCustomerRegion || false,
                shouldConsiderFuelSurcharge:
                  this.shouldConsiderFuelSurcharge || false,
              },
              DistanceBetweenHubs: null,
              AllowCrossdock,
              IsFinalMile,
              IsForReverse,
              AllowOvernightReception,
              Apartment,
              City,
              Color,
              Center: toFirestoreCoordinates,
              DoorNumber,
              Facility,
              DistributionZoneName: (DistributionZoneName || "").toUpperCase(),
              DistributionZoneId,
              DistributionZoneType: DistributionZoneType.value,
              PhoneNumber,
              PostalCode,
              Province,
              Region: this.Region.id,
              Size,
              NumberOfEmployees,
              Street,
              Vendor: DistributionZoneType.label === "STORE" ? Vendor : "",
              TimeZone,
              Country: Country.label,
              CountryCode: Country.value,
              DaysOfService: daysOfService,
            },
            { merge: true }
          );
          this.loading = false;
          // this.$emit('close');
          this.close();
          this.msg = "";
          this.isSaving = false;
          this.$notify({
            group: "zones",
            type: "success",
            title: "Distribution Zone created",
            text: `Distribution Zone ${DistributionZoneName} was created successfully`,
            duration: 3000,
          });
        } catch (err) {
          console.log("ERR: ", err);
          this.isSaving = false;
          this.msg = "Something went wrong, please try again.";
          this.$notify({
            group: "zones",
            type: "error",
            title: "Error creating zone",
            text: "Something went wrong, please try again.",
            duration: 3000,
          });
        }
      } else {
        this.isSaving = false;
        this.msg = "Name, street, city, province and postal code are required";
      }
    },
    async getAddressFromCoordinates() {
      this.isAddressLoading = true;
      const { lat, lng } = this.coordinates;
      const url = process.env.VUE_APP_REVERSE_GEOCODE;

      try {
        const response = await axios.post(url, {
          data: {
            latitude: lat,
            longitude: lng,
          },
        });
        const {
          countryCode,
          countryName,
          stateCode,
          state,
          county,
          city,
          district,
          street,
          postalCode,
          houseNumber,
        } = response.data;
        this.Street = street || "";
        this.DoorNumber = houseNumber || "";
        this.City = city || "";

        const province = store.getters.TaxProvinces.find(
          (province) => province.Province === state
        );
        this.Province = province ? province.Province : "";
        this.PostalCode = postalCode || "";
        this.Country = {
          label: countryName || "",
          value: countryCode || "",
        };
      } catch (error) {
        console.error("Error fetching address:", error);
        // this.err_message = 'Failed to fetch address from coordinates. Please enter manually.';
      } finally {
        this.isAddressLoading = false;
        // Use setTimeout to ensure Google API is fully loaded before initializing
        setTimeout(() => {
          this.initializeGoogleAutocomplete();
        }, 500);
      }
    },
    initializeGoogleAutocomplete() {
      const input = this.$refs.autocomplete;
      if (
        input &&
        window.google &&
        window.google.maps &&
        window.google.maps.places &&
        !this.autocomplete // Only initialize if not already initialized
      ) {
        const options = {
          types: [], // Restrict to addresses: https://developers.google.com/maps/documentation/javascript/supported_types
        };
        this.autocomplete = new window.google.maps.places.Autocomplete(
          input,
          options
        );
        this.autocomplete.addListener("place_changed", this.onPlaceChanged);

        // Ensure autocomplete dropdown appears over modal layers
        setTimeout(() => {
          const pacContainers = document.querySelectorAll(".pac-container");
          pacContainers.forEach((container) => {
            container.style.zIndex = "2000";
          });
        }, 100);
      } else if (
        !window.google ||
        !window.google.maps ||
        !window.google.maps.places
      ) {
        console.error("Google Maps API not loaded");
        // Try again after a delay if Google API isn't available yet
        setTimeout(() => {
          this.initializeGoogleAutocomplete();
        }, 1000);
      }
    },
    async getCoordinates() {
      const { Street, City, PostalCode, Province, Country } = this;

      this.geocoding_loading = true;
      const geocode_url =
        "https://us-central1-core-v2-34762.cloudfunctions.net/GEOCODE-functions-getOptimizerGeocode";
      const geocode_data = [
        {
          address:
            Street + " " + City + " " + Province ||
            "" + " " + Country.label ||
            "" + " " + PostalCode,
        },
      ];

      if (!Street || !PostalCode || !Province || !Country.label) {
        this.geocoding_loading = false;
        this.err_message = "Please enter a valid address";
        return;
      }
      await axios
        .post(geocode_url, { data: geocode_data })
        .then((response) => {
          this.geocoding_loading = false;
          if (response.data && response.data[0].geocodes) {
            this.Latitude = response.data[0].geocodes.lat;
            this.Longitude = response.data[0].geocodes.long;
            const gjLayer = window.L.geoJson(JSON.parse(geoJsonFeature));
            const firstPointResult = leafletPip.pointInLayer(
              [this.Longitude, this.Latitude],
              gjLayer
            );
            this.TimeZone =
              firstPointResult[0].feature.properties.tz_name1st || "";
          } else {
            this.err_message =
              "Coordinates not found. Please check the address or you can manually enter the coordinates";
          }
          // After getting coordinates, ensure the autocomplete is still active
        })
        .catch((error) => {
          console.log("geocoding error: ", error);
          this.geocoding_loading = false;
          this.err_message = "Internal error. Please contact Shyftbase team";
        });
      this.geocoding_loading = false;
    },
    async onPlaceChanged() {
      this.err_message = "";
      const addressObject = this.autocomplete.getPlace();

      const address = addressObject.address_components;
      const province = address
        ? address.filter((address_component) =>
          ["administrative_area_level_1"].some((word) =>
            address_component.types.includes(word)
          )
        )
        : null;

      const streetAddress = address
        ? address
          .filter((address_component) =>
            [
              "floor",
              "room",
              "route",
              "street_number",
              "street_address",
            ].some((word) => address_component.types.includes(word))
          )
          .map((a) => a.short_name)
          .join(" ")
        : null;

      const city = address
        ? address.filter((address_component) =>
          ["locality", "colloquial_area"].some((word) =>
            address_component.types.includes(word)
          )
        )
        : null;

      const postalCode = address
        ? address.filter((address_component) =>
          ["postal_code"].some((word) =>
            address_component.types.includes(word)
          )
        )
        : null;

      const country = address
        ? address.filter((address_component) =>
          ["country"].some((word) => address_component.types.includes(word))
        )
        : null;
      const _street = streetAddress;
      const _city = city.length && city[0] ? city[0].long_name : "";
      const _postalCode = postalCode.length ? postalCode[0].short_name : "";
      // TBD: Is it always full name? short name? all capital?
      const _province = province.length ? province[0].long_name : this.Province;
      const _country = country.length ? country[0].long_name : "";
      const _countryCode = country.length ? country[0].short_name : "";

      this.Street = _street;
      this.City = _city;
      this.PostalCode = _postalCode;

      const taxProvince = store.getters.TaxProvinces.find(
        (province) => province.Province === _province
      );
      this.Province = taxProvince ? taxProvince.Province : "";
      this.Country = {
        label: _country,
        value: _countryCode,
      };

      await this.getCoordinates();

      // After getting coordinates, ensure the autocomplete is still active
      this.$nextTick(() => {
        // Focus back on the input to allow continued autocomplete usage if needed
        if (this.$refs.autocomplete) {
          // Only set the value, don't blur or remove containers
          this.$refs.autocomplete.value = this.Street;
        }
      });
    },
    onInputFocus() {
      // Only initialize if not already initialized
      if (!this.autocomplete) {
        this.initializeGoogleAutocomplete();
      }
    },
    toggleDay(day) {
      this.daysOfService[day] = !this.daysOfService[day];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~leaflet/dist/leaflet.css";

.custom .leaflet-popup-tip,
.custom .leaflet-popup-content-wrapper {
  color: #ffffff;
}

select,
.select {
  width: 100%;
}

.box {
  padding: 1rem;
  margin-right: 0;
  width: 100%;
  max-width: none;
  box-shadow: none;
}

/* Target the modal container if it's using Bulma's modal class */
.modal-content,
.modal-card {
  margin: 0 auto;
  max-width: 100%;
}

/* Style for the tabs */
.tabs.is-success {
  li.is-active a {
    border-bottom-color: #007d6a;
    color: #007d6a;
    font-weight: 600;
  }

  a {
    &:hover {
      border-bottom-color: var(--primary);
      color: var(--primary);
    }
  }

  li a {
    color: var(--primary);
  }
}

/* Fixed height container for tab content */
.tab-content-container {
  min-height: 280px;
  position: relative;
}

.tab-content {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

/* Ensure Google Maps place autocomplete displays correctly */
:global(.pac-container) {
  z-index: 2000 !important;
  position: fixed !important;
  display: block !important;
  margin-top: 5px;
}

/* Hide pac-container when not needed */
:global(.pac-container:empty),
:global(.pac-container.pac-logo.hdpi:empty) {
  display: none !important;
}

/* Header field alignment styles */
.field {
  margin-bottom: 0;
}

.field .label {
  margin-bottom: 0.25rem;
}

.field .control {
  margin-bottom: 0;
}

/* Ensure consistent heights for header inputs and selects */
.field .input.is-small,
.field .select.is-small {
  height: 2.25rem;
  line-height: 1.5;
}
</style>
